<template>
  <div>


    <div class="card">

      <div class="card-header bg-white mb-5">

        <div class="row">
          <div class="col-6 mt-5">
            <h1 class="font-weight-900" style="text-decoration: underline">{{Hesap.adi}}</h1>
          </div>
          <div class="col-6 pull-right text-right">
            <img :src="Hesap.logo" alt="" width="180">
          </div>



        </div>

      </div>


      <div class="card-body p-3">


        <!---===== Print Area =======-->
        <div id="print-area">

          <div class="mt-3 mb-4"></div>
          <div class="row mb-5">

            <div class="col-md-6 mb-3 mb-sm-0 ml-5">


              <h5 class="font-weight-bold" style="text-decoration: underline; font-size: 8pt">{{Hesap.adi}} , {{Hesap.adres}} {{Hesap.pkodu}} {{Hesap.sehir}}</h5>

              <div class="col-sm-12 p-0" style="font-size: 12pt">{{Data.adi}}</div>
              <div class="col-sm-12 p-0" style="font-size: 12pt">{{Data.cfirma}}</div>
              <div class="col-sm- 12 p-0" style="font-size: 12pt">{{Data.adres}}</div>
              <div class="col-sm-12 p-0" style="font-size: 12pt">{{Data.cpkodu}} {{Data.csehir}}</div>


              <br>

              <div class="col-sm-6 p-0">

              </div>
            </div>


            <div class="col-md-6 text-sm-right">
              <h5 class="font-weight-bold"></h5>

              <div class="row">
                <div class="col-sm-8"></div>
                <div class="col-sm-4">


                </div>


              </div>


            </div>
          </div>


          <div class="row printtab">

            <div class="col-md-9">
              <h1 >{{$t("fatura.dfatura")}}</h1>
              <p style="font-size: 12pt">{{$t("fatura.baybayan")}}</p>
              <p style="font-size: 12pt">{{$t("fatura.baybayan1")}}</p>
            </div>

            <div class="col-md-3 pull-right ptarih">
              <div class="row pull-right">
                <div class="col-sm-12" style="font-size: 12pt">{{$t('fatura.dtarih')}}: {{Data.dtarihi}}</div>
                <div class="col-sm-12" style="font-size: 12pt">{{$t('fatura.ttarih')}}: {{Data.ttarihi}}</div>
                <div class="col-sm-12" style="font-size: 12pt">{{$t('fatura.fno')}}: {{Data.fno}}</div>
                <div class="col-sm-12" style="font-size: 12pt">{{$t('fatura.ilgili')}}: {{$store.state.KullaniciAdi}}</div>
              </div>
            </div>


            <div class="col-md-12">
              <table class="table table-hover mb-4">
                <thead class="bg-gray-300">
                <tr>
                  <th>{{$t('fatura.no')}}</th>
                  <th>{{$t('fatura.urun')}}</th>
                  <th>{{$t('fatura.miktar')}}</th>
                  <th>{{$t('fatura.bfiyat')}}</th>
                  <th>{{$t('fatura.vergi')}}</th>
                  <th>{{$t('fatura.vtutar')}}</th>
                  <th>{{$t('fatura.indirim')}}</th>
                  <th>{{$t('fatura.toplam')}}</th>
                  <th>
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(input, key) in Data.Urun" :key="input.id">
                  <td>{{input.id}}</td>
                  <td>
                    {{input.adi}}
                  </td>
                  <td>
                    {{input.miktar}}
                  </td>
                  <td>
                    {{Money(input.brfiyat)}}
                  </td>
                  <td>
                    {{input.vergi}} %
                  </td>
                  <td>
                    {{Money(input.vergitutar)}}
                  </td>

                  <td>
                    {{Money(input.indirim)}}
                  </td>
                  <td>
                    {{Money(input.toplam)}}
                  </td>
                  <td>


                  </td>
                </tr>

                </tbody>
              </table>

            </div>

            <div class="col-md-12 pull-right">
              <div class="invoice-summary pull-right">
                <p>{{$t('fatura.toplam')}}: <span>{{ Money(Data.alttoplam) }}</span></p>
                <p>{{$t('fatura.ktoplam')}}: <span>{{ Money(Data.vergi) }}</span></p>
                <h5 class="font-weight-bold">{{$t('fatura.gtoplam')}}: <span> {{ Money(Data.toplam) }}</span></h5>
              </div>
            </div>

            <div class="col-md-12 p-5 mt-5">
              <p></p>
              <p>{{Data.aciklama}}</p>
            </div>

            <div class="col-md-12 pull-right border-top pt-3 footerp">
              <div class="row">
                <div class="col-sm-4">
                  <div class="invoice-summary">
                    <p class="m-0">{{Hesap.adi}}</p>
                    <p class="m-0">{{Hesap.adres}}</p>
                    <p class="m-0">{{Hesap.pkodu}} {{Hesap.sehir}}</p>
                    <p class="m-0">Tel: {{Hesap.telefon}}</p>
                  </div>
                </div>
                <div class="col-sm-4 text-center">
                  <div class="invoice-summary">
                    <p class="m-0">Web: {{Hesap.web}}</p>
                    <p class="m-0">Email: {{Hesap.email}}</p>
                    <p>Fax: {{Hesap.faks}}</p>
                  </div>
                </div>
                <div class="col-sm-4 text-right pr-5">
                  <div class="invoice-summary">
                    <p class="m-0">{{Hesap.badi}}</p>
                    <p class="m-0">{{Hesap.iban}}</p>
                    <p class="m-0">{{Hesap.vdairesi}}</p>
                    <p class="m-0">{{Hesap.vno}}</p>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
  import notification from "@/notification";

  export default {
    data() {
      return {
        Data: [],
        Hesap: [],
      }
    },
    methods: {

      UrunListele() {
        this.$store.dispatch("dataver", {method: "get", url: "/fatura/1/" + this.$route.params.Fatura_id})
          .then(response => {
            if (response.Status == 'OK') {
              this.Data = response.Data;
              this.Data.Urun = response.Urun;
              this.Hesap = response.Hesap;
              console.log(response)
            } else {

            }
          });
      },

      Money(value) {
        let val = (value / 1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

    },
    created() {
      this.UrunListele();
    },

    computed: {},
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/Module/gider/fatura/detay.vue